export default class DB {
    constructor() {
        this.records={};
    }

    /**
     * Ajoute un modèle à la liste
     * @param {DataModel} model
     */
    addModel(model){
        if(!this.records[model.type]){
            this.records[model.type]={};
        }
        this.records[model.type][model.id]=model;
    }
    /**
     *
     * @param type
     * @param id
     * @return {DataModel}
     */
    getModel(type,id){
       return  this.records[type][id];
    }
}

DB.inst=new DB();